import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { firstBook, viewUrl } from '../data/library';
import { SectionHeading } from './SectionHeading';
const materials = ['Cardboard and cereal boxes', 'Paper and card', 'Scissors and sticky tape', 'String and rubber bands', 'Drinking straws and wooden skewers', 'Bottle caps and lids', 'Glue and markers'];
export function GettingStarted() {
  const summaryClass = 'flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 font-display text-[17px] font-semibold text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:px-6';
  return <section aria-label="Getting started" id="getting-started" className="scroll-mt-24" data-id="element-149" data-mp="1ym5mxr4dfz00">
      <SectionHeading index="05" title="Getting started" note="Three steps, then you are building." data-id="element-150" data-mp="23n36a714az33" />

      <div className="mt-10 grid gap-4 lg:grid-cols-3" data-id="element-151" data-mp="28lwmw8bpb67h">
        <details className="group rounded-[18px] border border-navy/10 bg-white" data-id="element-152" data-mp="tdxfgeilwu11">
          <summary className={summaryClass} data-id="element-153" data-mp="oekrfqg01gwv">
            <span className="flex items-center gap-3" data-id="element-154" data-mp="odjhjpapz0gq">
              <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sun font-sans text-[13px] font-semibold text-navy" data-id="element-155" data-mp="jeycnckivsly">
                1
              </span>
              Choose Book 01
            </span>
            <ChevronDownIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-navy/40 transition-transform duration-200 ease-out group-open:rotate-180" strokeWidth={2} data-id="element-156" data-mp="1752jrtwx6ahp" />
          </summary>
          <div className="px-5 pb-5 font-sans text-[14.5px] leading-relaxed text-navy/70 sm:px-6" data-id="element-157" data-mp="ybz7hoy0g3on">
            <p data-id="element-158" data-mp="1uvy3e3r81zdv">
              Open <span className="font-medium text-navy" data-id="element-159" data-mp="1uwhoftc653w4">01 {firstBook.title}</span> and pick any
              project that looks fun. The books do not have to be done in order.
            </p>
            <a href={viewUrl(firstBook.fileId)} target="_blank" rel="noreferrer" className="mt-3 inline-block rounded-lg font-sans text-[13.5px] font-medium text-navy underline decoration-sun decoration-2 underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-160" data-mp="3kcaez7w1913p">
              Open Book 01
            </a>
          </div>
        </details>

        <details className="group rounded-[18px] border border-navy/10 bg-white" data-id="element-161" data-mp="36i110flhjwoz">
          <summary className={summaryClass} data-id="element-162" data-mp="2roecfmjs8ez0">
            <span className="flex items-center gap-3" data-id="element-163" data-mp="2wlo99n9i3swv">
              <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sun font-sans text-[13px] font-semibold text-navy" data-id="element-164" data-mp="2wm6evai1zjhg">
                2
              </span>
              Gather your materials
            </span>
            <ChevronDownIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-navy/40 transition-transform duration-200 ease-out group-open:rotate-180" strokeWidth={2} data-id="element-165" data-mp="2fcvjqw4o2egn" />
          </summary>
          <div className="px-5 pb-5 sm:px-6" data-id="element-166" data-mp="2kb6paunxi2t2">
            <p className="font-sans text-[14.5px] leading-relaxed text-navy/70" data-id="element-167" data-mp="2kadtgoqicxpp">
              Each project lists what it needs. Most of it is already in the recycling:
            </p>
            <ul className="mt-3 space-y-1.5" data-id="element-168" data-mp="2u0yndyv8le2a">
              {materials.map(item => <li key={item} className="flex gap-2.5 font-sans text-[14px] leading-relaxed text-navy/70" data-id="element-169" data-mp="37zycf7mnvuyz">
                  <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-sun" data-id="element-170" data-mp="1dn02ip4vj0c6" />
                  {item}
                </li>)}
            </ul>
          </div>
        </details>

        <details className="group rounded-[18px] border border-navy/10 bg-white" data-id="element-171" data-mp="1a5uau29mr2gu">
          <summary className={summaryClass} data-id="element-172" data-mp="1f45gs1wt0sts">
            <span className="flex items-center gap-3" data-id="element-173" data-mp="1f34987ezyogt">
              <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sun font-sans text-[13px] font-semibold text-navy" data-id="element-174" data-mp="1k3rx4k7xip6t">
                3
              </span>
              Build together
            </span>
            <ChevronDownIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-navy/40 transition-transform duration-200 ease-out group-open:rotate-180" strokeWidth={2} data-id="element-175" data-mp="wdo0wxx2lrpu" />
          </summary>
          <div className="px-5 pb-5 font-sans text-[14.5px] leading-relaxed text-navy/70 sm:px-6" data-id="element-176" data-mp="165a9emi0xcow">
            <p data-id="element-177" data-mp="8ntq0lwbad88">
              Work through the steps alongside your child, and ask an adult to help whenever a
              project says so. First attempts often fail — that page is part of the build.
            </p>
          </div>
        </details>
      </div>
    </section>;
}